import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackwardArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "arrow-backward-icon",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	"aria-labelledby": titleId,
	ref,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M29 15H3h26zM10 7l-7 8 7-8zm0 17l-7-9 7 9z",
		strokeWidth: 2,
		stroke: "#000"
	})]
});
const ForwardRef = forwardRef(SvgBackwardArrow);
export { ForwardRef as ReactComponent };
